import { render, staticRenderFns } from "./NotificationItem.htm?vue&type=template&id=056b72a9&scoped=true&"
import script from "./NotificationItem.ts?vue&type=script&lang=js&"
export * from "./NotificationItem.ts?vue&type=script&lang=js&"
import style0 from "./NotificationItem.scss?vue&type=style&index=0&id=056b72a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b72a9",
  null
  
)

export default component.exports